module.exports = __webpack_public_path__ + "static/img/aboutbg001.1b5bd23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutbg001.png
// module id = 6JOg
// module chunks = 1